export enum ContextPages{
    Admin = '',
    Livescore = 'livescore',
    Readonly = 'readonly'
}